import DialogAccountDelete from '~/components/dialog/account/DialogAccountDelete.vue';
import DialogError from '~/components/dialog/error/DialogError.vue';

export const useAccountDelete = () => {
  const { t } = useI18n();
  const dialog = useDialogStore();

  const update = async () => {
    const { error } = await useApiFetch(URI.DeleteAccount, {
      method: 'POST',
    });
    if (!error) {
      window.location.href = '/logout';
    }
    return false;
  };

  const confirmDelete = () => {
    dialog.open(DialogAccountDelete, {
      level: DialogLevel.Settings,
      onCancel: () => {
        dialog.close();
      },
      onConfirm: async (value) => {
        dialog.close();
        try {
          const updated = await update();
          if (!updated) {
            dialog.open(DialogError, {
              level: DialogLevel.Settings,
              iconHeader: 'warning',
              label: t('error.request'),
            });
          }
        } catch (e) {
          globalThis.$logger.warn('error', e);
        }
      },
    });
  };

  return {
    confirmDelete,
  };
};
